import _ from "underscore";
import { push } from "connected-react-router";

import {
	CONTENT_NAVIGATION,
	ENTITY_VIEW_NAVIGATION,
	NAVIGATION_COMPLETE,
	WEB_PAGES_NAVIGATION,
	MEDIA_TAB_NAVIGATION,
	PREPARE_NAVIGATION,
	REPORT_TAB_NAVIGATION,
	SET_CURRENT_ZOOM,
	SET_VIDEO_TAB_FETCH_KEY,
	SOCIAL_MEDIA_TAB_NAVIGATION,
	VIDEO_TAB_NAVIGATION,
} from "actions/constants.js";
import {
	ENTITY_VIEW_INIT,
	ENTITY_VIEW_EXIT,
	ENTITY_VIEW_RESET_ALL_CURSOR_POS,
	ENTITY_VIEW_SET_GRAPH_DEPTH,
	ENTITY_VIEW_SET_GRAPH_EXPAND_DEPTH,
} from "actions/constants/entityViewActionTypes.js";
import {
	AGENTS_PATH,
	AGENTS_ROUTE,
	EXPLORER_PATH,
	EXPLORER_ROUTE,
	CONNECTOR_PATH,
	CONNECTOR_ROUTE,
	MEDIA_ROUTE,
	NARRATIVES_ROUTE,
} from "constants/constants.js";

import { SEARCH_STATE_IDS } from "actions/constants/stateIds.js";

import { resetGoogleTranslate } from "../lib/helpers/helpers";
import { fetchEventCorrelationInit } from "actions/compare.js";
import { getCrosstabsStatsAndTransition } from "actions/crosstabs.js";
import { updateData } from "actions/data.js";
import { updateDataCompare, updateDataMoe } from "actions/dataCompare.js";

import { 
	selectSearch,
	hydrateSearchState,
	updateQueryExpansion,
	checkResetQueryExpansion
} from "actions/searchActions";

import {
	setCurrentDatasetId,
	openDataExplorerContentModal,
	openDataExplorerPDFModal,
	setRequestedDocData,
} from "actions/dataExplorerActions.js";

import {
	DATASET_ID_RESUMES,
} from "layout/DataExplorer/DataExplorerConstants.js";

import {
	fetchContentArticles,
	fetchDataExplorerEntities,
	fetchEntityData,
	fetchEntityGraph,
	fetchEntityMediaMentions,
	fetchEntityTimeSeries,
	fetchSearchList,
	fetchUserSearches,
	fetchFilters,
	fetchVideoEntities,
	fetchVideoFilters,
	fetchVideoFeed,
	updateDataExplorerEntities,
} from "actions/fetch";

import { 
	clearFilters, 
} from "actions/searchActions.js";


import { mergeEntityFilters } from "@exovera/helpers";
import { addConfigFilters } from "lib/helpers/filterHelpers.js";
import { combineDataExlorerFilters } from "lib/helpers/dataExplorerHelpers.js";
import { updateMediaResults, setMediaComparableSearches } from "actions/mediaTab";
import { datasetUsesPdfModal } from "layout/DataExplorer/DataExplorerConstants.js";
import { getDatasetUrlPath, getDatasetIdFromPath } from "layout/DataExplorer/helpers";

// This is for the top level tab navigation
// If visiting the compare tab for the first time, populate the left side with data from whatever
//    tab we were on; otherwise populate with the exisitng data
// leftNarrative: object or false
// data: object. All the contents of the base reducer
export function compareNarratives() {
	return (dispatch, getState) => {
		const { userName } = getState().login;
		// FLAG_TEST_NAVIGATION
		const startNavigationDate = new Date();
		dispatch({ type: PREPARE_NAVIGATION, mode: "compare", userId: userName, startNavigationDate });
		// resetGoogleTranslate();
		setTimeout(() => {
			dispatch({ type: "compareNavigation" });
			const { varStore } = getState().storage;
			// console.log("varStore", varStore);

			const { activeNarrativeData, perspective, flatNarratives } = getState().base;
			const { showTopicsInGraph, projectMapConfig, aiToggleNoReaction } = getState().projectConfig;
			const { aiOnly } = getState().commonUI;
			const configStateFilter = projectMapConfig && projectMapConfig.compare && projectMapConfig.compare.state;

			const {
				activeSearchObj,
				currentEntityType,
				currentZoom,
				currentFiltersList,
				currentFiltersAndEntitiesList,
				currentFiltersMap,
				displayTimeEnd,
				displayTimeStart,
				entityFilterTypes,
				filters,
				filtersActive,
  			filterCategories, 
				timeEnd,
				timeStart,
			} = getState().search[SEARCH_STATE_IDS.NARRATIVES];

			const {
				firstHydration,
			} = getState().search[SEARCH_STATE_IDS.COMPARE_LEFT];

			if (!flatNarratives || flatNarratives.length <= 0) {
				console.error("compareNarratives - flatNarratives is empty", flatNarratives);
			}
			const basePerspective = perspective;
			// console.log("compare narratives default zoom", varStore.narratives[basePerspective].currentZoom);
			// console.log("compare narratives", activeNarrativeData, flatNarratives);

			// Left Side
			const leftPerspective = getState().leftCompare.perspective;
			const leftBaseFilters = leftPerspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
			// If no existing left narrative, use active narrative from Narratives tab
			const leftNarrative =
				varStore.left.narrative ||
				(showTopicsInGraph || activeNarrativeData.parent !== "self" ? activeNarrativeData : activeNarrativeData.children[0]);
			const leftZoom = varStore.left.narrative // if tab has been visited before
				? varStore.left[leftPerspective].currentZoom // use the store currentZoom
				: currentZoom; // otherwise

			const leftFiltersList = currentFiltersList;
			const leftEntityFiltersList = [];
			const hydrateLeftFilters = leftFiltersList;

			const leftMapHighlightId = varStore.left.narrative // if tab has been visited before
				? varStore.left[leftPerspective].mapHighlightId // use the store mapHighlightId
				: configStateFilter // otherwise check the config
				? configStateFilter.geoState
				: varStore.narratives[basePerspective].mapHighlightId; // if no config, use id from narratives
			const leftContentFilteredByDate = varStore.left.narrative ? varStore.left[leftPerspective].contentFilteredByDate : false;

			const rightPerspective = getState().rightCompare.perspective;
			const rightBaseFilters = rightPerspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
			const rightNarrative =
				varStore.right.narrative ||
				(showTopicsInGraph || activeNarrativeData.parent !== "self" ? activeNarrativeData : activeNarrativeData.children[0]);
			const rightZoom = varStore.right.narrative
				? varStore.right[rightPerspective].currentZoom
				: currentZoom;

			const rightFiltersList = currentFiltersList;
			const rightEntityFiltersList = [];
			const hydrateRightFilters = rightFiltersList;

			const rightMapHighlightId = varStore.right.narrative
				? varStore.right[rightPerspective].mapHighlightId
				: configStateFilter
				? configStateFilter.geoState
				: varStore.narratives[basePerspective].mapHighlightId;
			const rightContentFilteredByDate = varStore.right.narrative ? varStore.right[rightPerspective].contentFilteredByDate : false;
			const leftQuery = firstHydration ? activeSearchObj?.query : getState().leftCompare.activeSearchObj?.query;
			const rightQuery = firstHydration ? activeSearchObj?.query : getState().rightCompare.activeSearchObj?.query;


			dispatch({
				type: "hydrateLeftCompare",
				contentFilteredByDate: leftContentFilteredByDate,
				currentZoom: leftZoom,
				entityFilterTypes,
				filtersList: leftFiltersList,
				firstHydration,
				query: leftQuery,
				// keywords: leftKeywords,
				narrative: leftNarrative,
			});
			dispatch({
				type: "hydrateRightCompare",
				narrative: rightNarrative,
				contentFilteredByDate: rightContentFilteredByDate,
				currentZoom: rightZoom,
				filtersList: rightFiltersList,
				firstHydration,
				query: rightQuery,
				// keywords: rightKeywords,
			});

			const searchHydrateParams = {
				activeSearchObj,
				currentZoom,
				currentEntityType,
				currentFiltersList,
				currentFiltersAndEntitiesList,
				currentFiltersMap,
				displayTimeEnd,
				displayTimeStart,
				entityFilterTypes,
				filters,
				filtersActive,
  			filterCategories, 
				timeEnd,
				timeStart,
			}
			if (firstHydration) {
				dispatch(hydrateSearchState({
					stateId: SEARCH_STATE_IDS.COMPARE_LEFT,
					...searchHydrateParams,
				}))
				dispatch(hydrateSearchState({
					stateId: SEARCH_STATE_IDS.COMPARE_RIGHT,
					...searchHydrateParams,
				}))
			}

			// Force Source perspective if aiToggleNoReaction
			// if (aiOnly && aiToggleNoReaction && leftPerspective !== "Source") {
			// 	dispatch({
			// 		type: "togglePerspectiveLeft",
			// 		perspective: "Source",
			// 		filtersList: hydrateLeftFilters,
			// 	});
			// }
			// if (aiOnly && aiToggleNoReaction && rightPerspective !== "Source") {
			// 	dispatch({
			// 		type: "togglePerspectiveRight",
			// 		perspective: "Source",
			// 		filtersList: hydrateRightFilters,
			// 	});
			// }

			dispatch(
				updateDataCompare({
					side: "Left",
					activeFilters: hydrateLeftFilters,
					contentFilteredByDate: leftContentFilteredByDate,
					currentZoom: leftZoom,
					entityFilters: leftEntityFiltersList,
					eventMode: false,
					// keywords: leftKeywords,
					query: leftQuery,
					mapHighlightId: leftMapHighlightId,
					narrative: leftNarrative,
					// force Source perspective if aiToggleNoReaction
					perspective: aiOnly && aiToggleNoReaction ? "Source" : leftPerspective,
				})
			);
			dispatch(
				updateDataCompare({
					side: "Right",
					activeFilters: hydrateRightFilters,
					contentFilteredByDate: rightContentFilteredByDate,
					currentZoom: rightZoom,
					entityFilters: rightEntityFiltersList,
					eventMode: false,
					// keywords: rightKeywords,
					query: rightQuery,
					mapHighlightId: rightMapHighlightId,
					narrative: rightNarrative,
					// force Source perspective if aiToggleNoReaction
					perspective: aiOnly && aiToggleNoReaction ? "Source" : rightPerspective,
				})
			);

			// Update query Expansion for both sides
			dispatch(updateQueryExpansion(
				SEARCH_STATE_IDS.COMPARE_LEFT,
				getState().search[SEARCH_STATE_IDS.COMPARE_LEFT].activeSearchObj.query, 
				false,
				true,
				true
			));
			dispatch(updateQueryExpansion(
				SEARCH_STATE_IDS.COMPARE_RIGHT,
				getState().search[SEARCH_STATE_IDS.COMPARE_RIGHT].activeSearchObj.query, 
				false,
				true,
				true
			));

			// Highlight map if the project calls for it
			if (configStateFilter) {
				dispatch({
					type: "highlightMapLeft",
					data: configStateFilter,
					color: leftNarrative.color.dark,
					currentZoom: leftZoom,
				});
				dispatch({
					type: "highlightMapRight",
					data: configStateFilter,
					color: rightNarrative.color.dark,
					currentZoom: rightZoom,
				});
			}
		}, 30);
	};
}

// This is for the top level tab navigation
// If visiting the MOE tab for the first time, populate the right side with data from whatever
//    tab we were on; otherwise populate with the exisitng data
// leftNarrative: object or false
// data: object. All the contents of the base reducer
export function moeNavigation() {
	// console.log("moeNavigation");
	return (dispatch, getState) => {
		const { userName } = getState().login;
		dispatch({ type: PREPARE_NAVIGATION, mode: "moe", userId: userName });
		// resetGoogleTranslate();
		setTimeout(() => {
			dispatch({ type: "moeNavigation" });
			const { activeNarrativeData, currentZoom, moes, perspective } = getState().base;
			const { showTopicsInGraph, projectMapConfig } = getState().projectConfig;
			const { varStore } = getState().storage;
			const configStateFilter = projectMapConfig && projectMapConfig.moe && projectMapConfig.moe.state;
			const basePerspective = perspective;

			if (!moes || moes.length <= 0) {
				console.error("moeNavigation - moes are missing", moes);
			}

			// Left Side
			const leftPerspective = getState().leftCompare.perspective;
			const leftBaseFilters = leftPerspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
			// If no existing leftMOE, use first MOE with all options off
			const leftNarrative = varStore.leftMOE.narrative || moes[0];
			// If this is the first time going to the MOE page, use the zoom from Narratives
			const leftZoom = varStore.leftMOE.narrative ? varStore.leftMOE[leftPerspective].currentZoom : currentZoom;
			const leftFiltersList = varStore.leftMOE.narrative ? varStore.leftMOE[leftPerspective].filters : [];
			const leftEntitiesFiltersList = varStore.leftMOE.narrative ? varStore.leftMOE[leftPerspective].entityFilters : [];
			const hydrateLeftFiltersList = configStateFilter
				? addConfigFilters(leftFiltersList, configStateFilter, leftBaseFilters)
				: leftFiltersList;
			const leftMapHighlightId = varStore.leftMOE.narrative
				? varStore.leftMOE[leftPerspective].mapHighlightId
				: configStateFilter
				? configStateFilter.geoState
				: false;
			const leftContentFilteredByDate = varStore.leftMOE.narrative ? varStore.leftMOE[leftPerspective].contentFilteredByDate : false;

			const firstHydration = !varStore.left.narrative;

			const leftKeywords = firstHydration ? getState().base.activeKeywords : getState().leftCompare.activeKeywords;
			const rightKeywords = firstHydration ? getState().base.activeKeywords : getState().rightCompare.activeKeywords;
			// NOTE: the sanitizing removes all pre-existing filters
			// // All filters off except for the location (if one is set by via projectMapConfig)
			// const sanitizedFilters = reactivateFiltersByName(deactivateFilters(leftFilters), [
			// 	projectMapConfig.moe.state,
			// ]);
			// // just the project specific filter, but in the right format
			// const sanitizedFiltersList = parseActiveFilters(sanitizedFilters);

			dispatch(
				updateDataMoe({
					side: "Left",
					activeFilters: hydrateLeftFiltersList,
					contentFilteredByDate: leftContentFilteredByDate,
					currentZoom: leftZoom,
					entityFilters: leftEntitiesFiltersList,
					keywords: leftKeywords,
					mapHighlightId: leftMapHighlightId,
					narrative: leftNarrative,
					perspective: leftPerspective,
				})
			);
			dispatch({
				type: "hydrateLeftCompare",
				contentFilteredByDate: false,
				currentZoom: leftZoom,
				filtersList: hydrateLeftFiltersList,
				firstHydration,
				keywords: leftKeywords,
				narrative: leftNarrative,
			});

			const rightPerspective = getState().rightCompare.perspective;
			const rightBaseFilters = rightPerspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
			const rightNarrative =
				varStore.rightMOE.narrative ||
				(showTopicsInGraph || activeNarrativeData.parent !== "self" ? activeNarrativeData : activeNarrativeData.children[0]);
			const rightZoom = varStore.rightMOE.narrative ? varStore.rightMOE[rightPerspective].currentZoom : currentZoom;
			const rightFiltersList = varStore.rightMOE.narrative
				? varStore.rightMOE[rightPerspective].filters
				: varStore.narratives[rightPerspective].filters;
			const rightEntitiesFiltersList = varStore.rightMOE.narrative
				? varStore.rightMOE[rightPerspective].entityFilters
				: varStore.narratives[rightPerspective].entityFilters;
			const hydrateRightFiltersList = configStateFilter
				? addConfigFilters(rightFiltersList, configStateFilter, rightBaseFilters)
				: rightFiltersList;
			const rightMapHighlightId = varStore.rightMOE.narrative
				? varStore.rightMOE[rightPerspective].mapHighlightId
				: configStateFilter
				? configStateFilter.geoState
				: varStore.narratives[basePerspective].mapHighlightId;

			dispatch(
				updateDataMoe({
					side: "Right",
					activeFilters: hydrateRightFiltersList,
					contentFilteredByDate: false, // Currently no filtering by single date in the MOE
					currentZoom: rightZoom,
					entityFilters: rightEntitiesFiltersList,
					keywords: rightKeywords,
					mapHighlightId: rightMapHighlightId,
					narrative: rightNarrative,
					perspective: rightPerspective,
				})
			);

			dispatch({
				type: "hydrateRightCompare",
				contentFilteredByDate: false,
				currentZoom: rightZoom,
				filtersList: hydrateRightFiltersList,
				firstHydration,
				keywords: rightKeywords,
				narrative: rightNarrative,
			});
			// Highlight map if the project calls for it
			if (configStateFilter) {
				dispatch({
					type: "highlightMapLeft",
					data: configStateFilter,
					color: leftNarrative.color.dark,
					currentZoom: leftZoom,
				});
				dispatch({
					type: "highlightMapRight",
					data: configStateFilter,
					color: rightNarrative.color.dark,
					currentZoom: rightZoom,
				});
			}
		}, 30);
	};
}

// This is for the top level tab navigation
// If visiting the events tab for the first time, populate the left side with data from whatever
//    tab we were on; otherwise populate with the exisitng data
// leftNarrative: object or false
// data: object. All the contents of the base reducer
export const eventsNavigation = () => {
	// console.log("eventsNavigation");
	return (dispatch, getState) => {
		const { userName } = getState().login;
		dispatch({ type: PREPARE_NAVIGATION, mode: "events", userId: userName });
		// resetGoogleTranslate();
		setTimeout(() => {
			dispatch({ type: "eventsNavigation" });
			const { varStore } = getState().storage;
			const { activeNarrativeData, perspective, flatNarratives } = getState().base;
			const { eventFilters, eventTypes } = getState().events;
			const { showTopicsInGraph, projectMapConfig } = getState().projectConfig;
			const configStateFilter = projectMapConfig && projectMapConfig.compare && projectMapConfig.compare.state;

			if (!flatNarratives || flatNarratives.length <= 0) {
				console.error("eventsNarratives - flatNarratives is empty", flatNarratives);
			}
			const basePerspective = perspective;

			// Left Side
			const leftPerspective = getState().leftCompare.perspective;
			const leftBaseFilters = leftPerspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
			// If no existing left narrative, use active narrative from Narratives tab
			//		If active narrative is All Topics, use a different one
			const leftNarrative =
				varStore.leftEvent.narrative || (activeNarrativeData.children && activeNarrativeData.children.length > 0)
					? activeNarrativeData.children[0]
					: activeNarrativeData;
			// (showTopicsInGraph || activeNarrativeData.parent !== "self"
			// 	? activeNarrativeData
			// 	: activeNarrativeData.children[0]);
			const leftZoom = varStore.leftEvent.narrative // if tab has been visited before
				? varStore.leftEvent[leftPerspective].currentZoom // use the store currentZoom
				: varStore.narratives[basePerspective].currentZoom; // otherwise
			const leftFiltersList = varStore.leftEvent.narrative
				? varStore.leftEvent[leftPerspective].filters
				: varStore.narratives[leftPerspective].filters;
			const leftEntityFiltersList = varStore.leftEvent.narrative
				? varStore.leftEvent[leftPerspective].entityFilters
				: varStore.narratives[leftPerspective].entityFilters;

			const hydrateLeftFilters = configStateFilter
				? addConfigFilters(leftFiltersList, configStateFilter, leftBaseFilters)
				: leftFiltersList;
			const leftMapHighlightId = varStore.leftEvent.narrative // if tab has been visited before
				? varStore.leftEvent[leftPerspective].mapHighlightId // use the store mapHighlightId
				: configStateFilter // otherwise check the config
				? configStateFilter.geoState
				: varStore.narratives[basePerspective].mapHighlightId; // if no config, use id from narratives
			const leftContentFilteredByDate = varStore.leftEvent.narrative ? varStore.leftEvent[leftPerspective].contentFilteredByDate : false;
			// : varStore.narratives[basePerspective].contentFilteredByDate;

			const firstHydration = !varStore.leftEvent.narrative;

			// NOTE: Events dont' have reaction data
			const rightBaseFilters = eventFilters;
			const rightNarrative = varStore.rightEvent.narrative || eventTypes[0];
			const rightZoom = varStore.rightEvent.narrative ? varStore.rightEvent.Source.currentZoom : leftZoom;
			const rightFiltersList = varStore.rightEvent.narrative ? varStore.rightEvent.Source.filters : [];
			const hydrateRightFilters = configStateFilter
				? addConfigFilters(rightFiltersList, configStateFilter, rightBaseFilters)
				: rightFiltersList;
			const rightMapHighlightId = varStore.rightEvent.narrative
				? varStore.rightEvent.Source.mapHighlightId
				: configStateFilter
				? configStateFilter.geoState
				: leftMapHighlightId;
			const rightContentFilteredByDate = varStore.rightEvent.narrative
				? varStore.rightEvent.Source.contentFilteredByDate
				: leftContentFilteredByDate;

			const leftKeywords = firstHydration ? getState().base.activeKeywords : getState().leftCompare.activeKeywords;
			const rightKeywords = firstHydration ? getState().base.activeKeywords : getState().rightCompare.activeKeywords;

			dispatch(
				fetchEventCorrelationInit({
					primary: leftNarrative,
					secondary: rightNarrative,
					// just the remaining events
					eventsToFetch: _.reject(eventTypes, (event) => {
						return event.id === rightNarrative.id;
					}),
					activeFilters: hydrateRightFilters,
				})
			);

			dispatch(checkResetQueryExpansion(SEARCH_STATE_IDS.COMPARE_LEFT));
			dispatch(checkResetQueryExpansion(SEARCH_STATE_IDS.COMPARE_RIGHT));

			dispatch({
				type: "hydrateLeftCompare",
				narrative: leftNarrative,
				contentFilteredByDate: leftContentFilteredByDate,
				currentZoom: leftZoom,
				filtersList: leftFiltersList,
				firstHydration,
				keywords: leftKeywords,
			});
			dispatch({
				type: "hydrateRightCompare",
				narrative: rightNarrative,
				contentFilteredByDate: rightContentFilteredByDate,
				currentZoom: rightZoom,
				filtersList: rightFiltersList,
				firstHydration,
				keywords: rightKeywords,
			});

			dispatch(
				updateDataCompare({
					side: "Right",
					activeFilters: hydrateRightFilters,
					contentFilteredByDate: rightContentFilteredByDate,
					currentZoom: rightZoom,
					entityFilters: [],
					eventMode: true,
					keywords: rightKeywords,
					mapHighlightId: rightMapHighlightId,
					narrative: rightNarrative,
					perspective: "Source",
				})
			);
			dispatch(
				updateDataCompare({
					side: "Left",
					activeFilters: hydrateLeftFilters,
					contentFilteredByDate: leftContentFilteredByDate,
					currentZoom: leftZoom,
					entityFilters: leftEntityFiltersList,
					eventMode: true,
					keywords: leftKeywords,
					mapHighlightId: leftMapHighlightId,
					narrative: leftNarrative,
					perspective: leftPerspective,
				})
			);

			// Highlight map if the project calls for it
			if (configStateFilter) {
				dispatch({
					type: "highlightMapLeft",
					data: configStateFilter,
					color: leftNarrative.color.dark,
					currentZoom: leftZoom,
				});
				dispatch({
					type: "highlightMapRight",
					data: configStateFilter,
					color: rightNarrative.color.dark,
					currentZoom: rightZoom,
				});
			}
		}, 30);
	};
};

// Close compare mode
export function narrativeNavigation() {
	return (dispatch, getState) => {
		const stateId = SEARCH_STATE_IDS.NARRATIVES;
		const { userData, userName } = getState().login;
		dispatch(checkResetQueryExpansion(stateId));
		dispatch({ type: PREPARE_NAVIGATION, mode: NARRATIVES_ROUTE, userId: userName });
		// resetGoogleTranslate();
		setTimeout(() => {
			const { searches } = getState().search[stateId];
			const searchesNeeded = !searches || searches.length === 0;
			const userPool = userData && userData.pool && userData.pool.userPoolId;
			dispatch({ type: "narrativeNavigation" });
			if (searchesNeeded) {
				dispatch(fetchSearchList(stateId));
				dispatch(fetchUserSearches({ 
					userId: `${userName}_${userPool}`, 
					stateId,
					selectSearch,
				}));
			}
			// dispatch({ type: "highlightCountyOffLeft" });
			// dispatch({ type: "highlightCountyOffRight" });
		}, 30);
	};
}

export const narrativeNavigationOverride = (params) => {
	const {
		narrative,
		perspective,
		currentZoom,
		activeFilters,
		entityFilters,
		keywords,
		mapHighlightId,
		contentFilteredByDate,
		currentFilters,
	} = params;
	return (dispatch, getState) => {
		const { userName } = getState().login;
		dispatch({ type: PREPARE_NAVIGATION, mode: NARRATIVES_ROUTE, userId: userName });
		// resetGoogleTranslate();
		setTimeout(() => {
			dispatch({ type: "narrativeNavigation" });
			dispatch({ type: "setActiveNarrativeFromShare", activeNarrativeData: narrative });
			dispatch({ type: SET_CURRENT_ZOOM, currentZoom });
			dispatch({ type: "setVisibleKeywordsFromSaved", newKeywords: keywords });
			dispatch(
				updateData({
					nar: narrative,
					perspective,
					currentZoom,
					activeFilters,
					entityFilters,
					keywords,
					mapHighlightId,
					contentFilteredByDate,
					currentFilters,
					// dontUpdateMap: true,
				})
			);
			dispatch(push("/narratives"));
		}, 30);
	};
};

// Open Graph mode
export function seedGraphTab() {
	return (dispatch, getState) => {
		const { userName } = getState().login;
		dispatch({ type: PREPARE_NAVIGATION, mode: "graph", userId: userName });
		// resetGoogleTranslate();
		setTimeout(() => {
			const { availableLines } = getState().graphTab;
			const { percentageTypes } = getState().projectConfig;
			// if we're returning the the graph tab, just keep the tab intact
			if (availableLines.length > 0) {
				dispatch({ type: "graphNavigation" });
			} else {
				// Generate data from a seed narrative
				// TODO: Once the CONTENT_TAB exists, seedGraphTab will need to work without activeNarrativeData
				// - can we just call graphNavigation then too?
				const { activeNarrativeData } = getState().base;
				const seedNarrative = !_.isEmpty(activeNarrativeData)
					? // Same logic as compare/moe/event navigation
					  activeNarrativeData.children && activeNarrativeData.children.length > 0
						? activeNarrativeData.children[0]
						: activeNarrativeData
					: false;
				dispatch({ type: "seedGraphTab", seedNarrative, percentageTypes });
			}
		}, 30);
	};
}

// Open graph mode when there is no data yet. This is just navigation - does no actual data handling
export function graphNavigation() {
	return (dispatch, getState) => {
		const { userName } = getState().login;
		dispatch({ type: PREPARE_NAVIGATION, mode: "graph", userId: userName });
		setTimeout(() => {
			dispatch({ type: "graphNavigation" });
		}, 30);
	};
}

// Open Content mode
export function contentNavigation() {
	return (dispatch, getState) => {
		const { userName } = getState().login;
		const { dateStart, dateEnd, filters } = getState().contentTab;
		dispatch({ type: PREPARE_NAVIGATION, mode: "curated", userId: userName });
		// resetGoogleTranslate();
		dispatch(
			fetchContentArticles({ filters, dateStart, dateEnd, aiOverride: false, keywords: [], share: false, shareSingleArticleId: false })
		);
		setTimeout(() => {
			dispatch({ type: CONTENT_NAVIGATION });
		}, 30);
	};
}

// Open Entity View
export function entityViewNavigation(datasetId, entity, preNavMode, updatePath=true) {
	return (dispatch, getState) => {
		const { api, currentProject, availableProjects } = getState().login;
		const { entityDataLoading, requestedEntityData} = getState().entityView;
		const explorerDatasets = getState().projectConfig.explorerDatasets;
		const entityChanged = (entity?.id !== requestedEntityData?.id) || (entity?.index !== requestedEntityData?.index);
		const navMode = preNavMode || "explorer";

		// Wait for API details to be configured
		if (_.isEmpty(api)) {
			setTimeout(() => {
				dispatch(entityViewNavigation(datasetId, entity, navMode, updatePath));
			}, 200);
			return;
		}

		if (datasetId && entity?.id && entity?.index && (entityChanged && !entityDataLoading)) {
			dispatch({ type: PREPARE_NAVIGATION, mode: navMode });
			dispatch(setCurrentDatasetId(datasetId, explorerDatasets));
			dispatch({ type: ENTITY_VIEW_INIT, entity });
			dispatch({ type: ENTITY_VIEW_RESET_ALL_CURSOR_POS });
			// Resumes dataset is highly connected, currently always force an 
			// graph depth of 1 to ensure initial load time is limited
			if (datasetId === DATASET_ID_RESUMES) {
				dispatch({type: ENTITY_VIEW_SET_GRAPH_DEPTH, depth: "1"});
				dispatch({type: ENTITY_VIEW_SET_GRAPH_EXPAND_DEPTH, depth: "1"});
			}
			const { graphDepth } = getState().entityView;
			dispatch(fetchEntityData({...entity, dataset: datasetId}));
			dispatch(fetchEntityGraph(entity, graphDepth));
			// Fetching time series chart will initiate fetch of media mentions
			// upon return (once total time range of media mentions is known)
			if (datasetId !== DATASET_ID_RESUMES) {
				dispatch(fetchEntityTimeSeries({entity}));
			}
			setTimeout(() => {
				dispatch({ type: ENTITY_VIEW_NAVIGATION, mode: navMode });
				if (updatePath) {
					const matchingProject = availableProjects.find(x => x.id === currentProject)
					const urlParams = "?project=" + encodeURIComponent(matchingProject.name);
					dispatch(push("/" + getDatasetUrlPath(datasetId) + "/" + entity.index + "/" + entity.id + urlParams));
				}
			}, 30);
		}
	};
}

// Close Entity View
export function entityViewExitNavigation() {
	return (dispatch, getState) => {
		const { lastNavMode } = getState().base;
		const {currentDatasetId} = getState().dataExplorer;
		document.getElementById("appLayout").scrollTop = 0;
		dispatch({ type: ENTITY_VIEW_EXIT });
		switch(lastNavMode) {
			case AGENTS_ROUTE:
				dispatch(agentsNavigation());
				break;
			case CONNECTOR_ROUTE:
				dispatch(connectorNavigation());
				break;
			default:
				dispatch(explorerNavigation());
				break;
		}
	};
}

// Open Media Tab
export function mediaTabNavigation() {
	return (dispatch, getState) => {
		const { userName } = getState().login;
		const stateId = SEARCH_STATE_IDS.MEDIA;
		dispatch(checkResetQueryExpansion(stateId));
		dispatch({ type: PREPARE_NAVIGATION, mode: MEDIA_ROUTE, userId: userName });
		// resetGoogleTranslate();
		setTimeout(() => {
			const { searches, filters } = getState().search[stateId];
			const { userData, userName } = getState().login;
			const searchesNeeded = !searches || searches.length === 0;
			const filtersNeeded = !filters || filters.length === 0;
			const userPool = userData && userData.pool && userData.pool.userPoolId;

			// Conditionally fetch searches
			dispatch({ type: MEDIA_TAB_NAVIGATION, payload: { tabSpinner: searchesNeeded } });
			if (filtersNeeded) {
				dispatch(fetchFilters(stateId));
			}
			if (searchesNeeded) {
				dispatch(fetchSearchList(stateId));
				dispatch(fetchUserSearches({ 
					userId: `${userName}_${userPool}`, 
					stateId, 
					selectSearch,
					setComparableSearches: setMediaComparableSearches,
					updateResults: updateMediaResults,
				}));
			}
		}, 500);
	};
}

// Open Report tab
export function reportTabNavigation() {
	return (dispatch, getState) => {
		const { userName } = getState().login;
		dispatch({ type: PREPARE_NAVIGATION, mode: "reports", userId: userName });
		// resetGoogleTranslate();
		setTimeout(() => {
			dispatch({ type: REPORT_TAB_NAVIGATION });
		}, 30);
	};
}

// Open Social tab
export function socialNavigation() {
	const stateId = SEARCH_STATE_IDS.SOCIAL_MEDIA;
	return (dispatch, getState) => {
		const { userName } = getState().login;
		const { filters } = getState().search[stateId];
		const needToFetchFilters = !filters || filters.length === 0;

		// resetGoogleTranslate();
		dispatch(checkResetQueryExpansion(stateId));
		dispatch({ type: PREPARE_NAVIGATION, mode: "social", userId: userName });
		if (needToFetchFilters) {
			dispatch(fetchFilters(stateId));
		}

		setTimeout(() => {
			dispatch({ type: SOCIAL_MEDIA_TAB_NAVIGATION });
		}, 30);
	};
}

// Open Video tab
export function videoNavigation() {
	return (dispatch, getState) => {
		// resetGoogleTranslate();
		const { videoFeed, activeFilters, entityFilters, keywordFilters, endDate, startDate } = getState().videoTab;
		const { videoTabEntities } = getState().projectConfig;
		const { userName } = getState().login;
		const needData = !videoFeed;
		const fetchKey = `videoRequest_${Date.now()}`;

		const filtersList = mergeEntityFilters({
			activeFilters,
			entityFilters,
			keywords: keywordFilters,
			// keywords: false, // handled separately
			perspective: "Source", // required for entities
		});

		dispatch({ type: PREPARE_NAVIGATION, mode: "video", userId: userName });
		dispatch({ type: SET_VIDEO_TAB_FETCH_KEY, fetchKey });

		setTimeout(() => {
			dispatch({ type: VIDEO_TAB_NAVIGATION, needData });
			if (needData) {
				dispatch(fetchVideoFilters());
				dispatch(fetchVideoFeed({ filtersList, keywords: keywordFilters, endDate, startDate, fetchKey }));
				if (videoTabEntities) {
					dispatch(fetchVideoEntities({ filtersList, keywords: keywordFilters, endDate, startDate, fetchKey }));
				}
			}
		}, 30);
	};
}

// Open Crosstabs tab
export function crosstabsNavigation() {
	return (dispatch, getState) => {
		const { userName } = getState().login;
		dispatch({ type: PREPARE_NAVIGATION, mode: "crosstabs", userId: userName });
		// resetGoogleTranslate();
		setTimeout(() => {
			const { forceCrosstabsEntity } = getState().projectConfig;
			dispatch({ type: NAVIGATION_COMPLETE });
			if (forceCrosstabsEntity) {
				dispatch(getCrosstabsStatsAndTransition({ entityString: forceCrosstabsEntity }));
			}
		}, 30);
	};
}

// Open Explorer tab
export function explorerNavigation(datasetId, index, id, routerInitiated=false) {
	const stateId = SEARCH_STATE_IDS.EXPLORER;
	return (dispatch, getState) => {

		// Wait for API details to be configured
		const { userName, api } = getState().login;
		if (_.isEmpty(api)) {
			setTimeout(() => {
				dispatch(explorerNavigation(datasetId, index, id, routerInitiated));
			}, 200);
			return;
		}

		const { currentProject, availableProjects } = getState().login;
		const { location } = getState().router;
		const { filters } = getState().search[stateId];
		const { currentDatasetId, requestedDocIndex, requestedDocId } = getState().dataExplorer;
		const explorerDatasets = getState().projectConfig.explorerDatasets;
		const requestedDatasetValid = !!(datasetId && datasetId.length > 0 && explorerDatasets.find(x => x.id === datasetId));
		const haveValidId = Boolean(requestedDatasetValid && index && index.length > 0 && id && id.length > 0);
		const datasetIdToUse = (requestedDatasetValid && datasetId) || currentDatasetId; 
		const datasetPathToUse = getDatasetUrlPath(datasetIdToUse);
		const haveValidDataset = datasetIdToUse && (datasetIdToUse.length > 0);
		const changingPathRoot = !location.pathname.startsWith(EXPLORER_PATH);
		const changingDataset = haveValidDataset && (datasetIdToUse !== currentDatasetId);
		const noIndexes = !index && !requestedDocIndex;
		const changingIndex = !noIndexes && (index !== requestedDocIndex);
		const noIds = !id && !requestedDocId;
		const changingId = !noIds && (id !== requestedDocId);
		const changingPath = changingPathRoot || changingDataset || changingIndex || changingId;
		const isPDF = datasetUsesPdfModal(datasetIdToUse);
		const needToFetchFilters = !filters || filters.length === 0 || changingDataset;

		dispatch(checkResetQueryExpansion(stateId));
		dispatch({ type: PREPARE_NAVIGATION, mode: EXPLORER_ROUTE, userId: userName });


		if (needToFetchFilters) {
			dispatch(clearFilters(stateId));
			dispatch(fetchFilters(stateId, datasetIdToUse));
		}	

		if (changingPath || routerInitiated) {
			let pathToUse = EXPLORER_PATH;
			if (datasetPathToUse && datasetPathToUse.length > 0) {
				pathToUse += "/" + datasetPathToUse;
			}
			if (haveValidId) {
				pathToUse += "/" + index;
				pathToUse += "/" + id;
			}
			const newPathChangesRoute = pathToUse && pathToUse !== location.pathname;
			if (routerInitiated || newPathChangesRoute) {
				// Configure relevant dataset
				if (changingDataset) {
					dispatch(setCurrentDatasetId(datasetIdToUse, explorerDatasets));
					dispatch(updateDataExplorerEntities());
				}
				// Configure relevant document details
				if (changingIndex || changingId) {
					dispatch(setRequestedDocData(datasetIdToUse, index, id));
				}
				// Load document data and open modal if specific doc id is requested
				if (routerInitiated && haveValidId) {			
					dispatch(isPDF 
						? openDataExplorerPDFModal({id, index, dataset: datasetIdToUse}) 
						: openDataExplorerContentModal({dataset: datasetIdToUse, id, index})
					);
				}
			}
			if (newPathChangesRoute) {
				const matchingProject = availableProjects.find(x => x.id === currentProject)
				const urlParams = haveValidId ? "?project=" + encodeURIComponent(matchingProject.name) : "";
				dispatch(push(pathToUse + urlParams));
			}
		}

		setTimeout(() => {
			dispatch({ type: NAVIGATION_COMPLETE });
		}, 30);

	};
}

// Open Data Connector tab
export function connectorNavigation(datasetId, index, id, routerInitiated=false) {
	const stateId = SEARCH_STATE_IDS.CONNECTOR;
	return (dispatch, getState) => {

		// Wait for API details to be configured
		const { userName, api } = getState().login;
		if (_.isEmpty(api)) {
			setTimeout(() => {
				dispatch(connectorNavigation(dataset, index, id, routerInitiated));
			}, 200);
			return;
		}

		const { currentProject, availableProjects } = getState().login;
		const { location } = getState().router;
		const { filters } = getState().search[stateId];
		const { explorerDatasets } = getState().projectConfig;
		const { requestedDocDataset, requestedDocIndex, requestedDocId } = getState().dataExplorer;

		const requestedDatasetValid = !!(datasetId && datasetId.length > 0 && explorerDatasets.find(x => (x.id === datasetId) && x.connected));
		const datasetIdToUse = (requestedDatasetValid && datasetId) || requestedDocDataset; 
		const datasetPathToUse = getDatasetUrlPath(datasetIdToUse);
		const haveValidDataset = datasetIdToUse && (datasetIdToUse.length > 0);
		const haveValidId = Boolean(requestedDatasetValid && index && index.length > 0 && id && id.length > 0);

		const noIndexes = !index && !requestedDocIndex;
		const noIds = !id && !requestedDocId;

		const changingDataset = haveValidDataset && (datasetIdToUse !== requestedDocDataset);
		const changingIndex = !noIndexes && (index !== requestedDocIndex);
		const changingId = !noIds && (id !== requestedDocId);
		const changingPathRoot = !location.pathname.startsWith(CONNECTOR_PATH);
		const changingPath = changingPathRoot || changingDataset || changingIndex || changingId;
		const isPDF = datasetUsesPdfModal(datasetIdToUse);
		const needToFetchFilters = !filters || filters.length === 0;

		dispatch(checkResetQueryExpansion(stateId));
		dispatch({ type: PREPARE_NAVIGATION, mode: CONNECTOR_ROUTE, userId: userName });

		if (needToFetchFilters) {
			dispatch(clearFilters(stateId));
			dispatch(fetchFilters(stateId));
		}	

		if (changingPath || routerInitiated) {
			let pathToUse = CONNECTOR_PATH;
			if (haveValidId) {
				pathToUse += "/" + datasetPathToUse;
				pathToUse += "/" + index;
				pathToUse += "/" + id;
			}
			const newPathChangesRoute = pathToUse && pathToUse !== location.pathname;
			if (routerInitiated || newPathChangesRoute) {
				// Configure relevant document details
				if (changingDataset || changingIndex || changingId) {
					dispatch(setRequestedDocData(datasetIdToUse, index, id));
				}
				// Load document data and open modal if specific doc id is requested
				if (routerInitiated && haveValidId) {
					dispatch(isPDF 
						? openDataExplorerPDFModal({id, index, dataset: datasetIdToUse}) 
						: openDataExplorerContentModal({dataset: datasetIdToUse, id, index})
					);
				}
			}
			if (newPathChangesRoute) {
				const matchingProject = availableProjects.find(x => x.id === currentProject)
				const urlParams = haveValidId ? "?project=" + encodeURIComponent(matchingProject.name) : "";
				dispatch(push(pathToUse + urlParams));
			}
		}

		setTimeout(() => {
			dispatch({ type: NAVIGATION_COMPLETE });
		}, 30);

	};
}

// Open Web Pages tab
export function webPagesNavigation() {
	return (dispatch, getState) => {
		// resetGoogleTranslate();
		const { userName } = getState().login;
		dispatch({ type: PREPARE_NAVIGATION, mode: "web", userId: userName });

		setTimeout(() => {
			dispatch({ type: NAVIGATION_COMPLETE });
		}, 30);
	};
}

// Open Agents tab
export function agentsNavigation() {
	return (dispatch, getState) => {
		// resetGoogleTranslate();
		const { userName } = getState().login;
		dispatch({ type: PREPARE_NAVIGATION, mode: AGENTS_ROUTE, userId: userName });
		dispatch(push(AGENTS_PATH));

		setTimeout(() => {
			dispatch({ type: NAVIGATION_COMPLETE });
		}, 30);
	};
}

// Open Ask Sage tab
export function askSageTabNavigation() {
	return (dispatch, getState) => {
		// resetGoogleTranslate();
		const { userName } = getState().login;
		dispatch({ type: PREPARE_NAVIGATION, mode: "asksage", userId: userName });

		setTimeout(() => {
			dispatch({ type: NAVIGATION_COMPLETE });
		}, 30);
	};
}

// Open Help page
export function helpNavigation() {
	return (dispatch, getState) => {
		resetGoogleTranslate();
		const { userName } = getState().login;
		dispatch({ type: PREPARE_NAVIGATION, mode: "help", userId: userName });
		dispatch(push("/help"));

		setTimeout(() => {
			dispatch({ type: NAVIGATION_COMPLETE });
		}, 30);
	};
}

// Open Data Catalog page
export function dataCatalogNavigation(datasetId) {
	return (dispatch, getState) => {
		resetGoogleTranslate();
		const { userName } = getState().login;
		dispatch({ type: PREPARE_NAVIGATION, mode: "catalog", userId: userName });
		dispatch(push("/catalog" + (datasetId ? "#" + datasetId : "")));

		setTimeout(() => {
			dispatch({ type: NAVIGATION_COMPLETE });
		}, 30);
	};
}